import { createSelector } from '@ngrx/store';
import { selectAllFraudRules, selectFraudRuleEntities } from '../reducer/cart.reducer';
import { selectCartState } from './cart.selectors';

export const selectFraudRulesState = createSelector(selectCartState, (state) => state.fraudRules);

export const selectAllFraudRulesList = createSelector(selectFraudRulesState, selectAllFraudRules);

export const selectFraudRuleEntitiesMap = createSelector(selectFraudRulesState, selectFraudRuleEntities);

export const selectFraudRuleById = (id: string) =>
    createSelector(selectFraudRuleEntitiesMap, (entities) => entities[id] || null);

export const selectFraudRulesAvailableProductLines = createSelector(
    selectCartState,
    (state) => state.fraudRulesAvailableProductLines,
);
